import { BaseChartComponent, get } from './charts-shared';

const ELEMENT_SELECTOR = '#daily-performance-chart';
const MASTER_DATA = window.shareClassReportingData || {};

export default class DailyPerformanceChartComponent extends BaseChartComponent {
  constructor() {
    super(ELEMENT_SELECTOR, MASTER_DATA);
    this.mapData = (series) => {
      const data = get(series, 'charts.prices.series');

      const performanceData = [];
      const indexData = [];
      if (Array.isArray(data)) {
        data.forEach((d) => {
          const time = new Date(d.date).getTime();
          performanceData.push([time, parseFloat(d.shareclass)]);
          indexData.push([time, parseFloat(d.index)]);
        });
      }

      return {
        performanceData,
        indexData,
      };
    };
  }

  makeChart() {
    const series = [
      {
        name: Drupal.t('Performance'),
        data: this.data.performanceData,
      },
      {
        name: Drupal.t('Index'),
        data: this.data.indexData,
      },
    ];

    const filledSeries = series.filter((s) => {
      const seriesIsEmpty = s.data.some((d) => {
        return Number.isNaN(d[1]);
      });

      return !seriesIsEmpty;
    });

    Highcharts.stockChart(this.element.attr('id'), {
      rangeSelector: {
        selected: 5,
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: true,
      },
      series: filledSeries,
    });

    const periodSelector = document.getElementById(ELEMENT_SELECTOR.replace('#', '')).getElementsByTagName('select');

    Object.entries(periodSelector).forEach(([key, value]) => {
      value.classList.add('no-chosen');
    });
  }
}
